import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import * as actions from './store/binaryImageTypeActions';
import { hasPermission } from '../../sc-utilities';
import BinaryImageTypeForm from './BinaryImageTypeForm';
import History from "../../../History";


const BinaryImageTypeCreate = props => {
    const { loading, activeCustomer, translations, permissions, onCreateBinaryImage } = props;

    const handleSubmit = async data => {
        let requestData = { ...data, ActiveCustomerID: activeCustomer }
        let result = await onCreateBinaryImage(requestData);
        if (result) {
            History.goBack();
        }
    };

    const cancelHandler = () => {
        History.goBack();
    };

    let initialValues = {
        Key: "",
        Name: ""
    };
    let formSettings = {
        Validation: {
            Key: Yup.string().required("Required"),
            Name: Yup.string().required("Required")
        },
        FormTitle: translations['create_binary_image_type'] || "Create binary image type",
        ButtonSubmit: hasPermission(permissions, 'binary_image_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "Cancel",
            handleCancel: cancelHandler
        }
    };


    return (
        <BinaryImageTypeForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            loading={loading}
            translations={translations}
        />
    )
}


const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.exportImport.binaryImageType.creating,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onCreateBinaryImage: data => dispatch(actions.createBinaryImageType(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BinaryImageTypeCreate);